// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file common/v1/payment_errors.proto (package common.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * Defines error codes in case of failure response from pay request.
 * This enum can grow as we support more errors.
 *
 * @generated from enum common.v1.PayRequestErrorCode
 */
export const PayRequestErrorCode = proto3.makeEnum(
  "common.v1.PayRequestErrorCode",
  [
    {no: 0, name: "PAY_REQUEST_ERROR_CODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PAY_REQUEST_ERROR_CODE_BLOCKED", localName: "BLOCKED"},
    {no: 2, name: "PAY_REQUEST_ERROR_CODE_INSUFFICIENT_FUNDS", localName: "INSUFFICIENT_FUNDS"},
    {no: 3, name: "PAY_REQUEST_ERROR_CODE_INVALID_PAYLOAD", localName: "INVALID_PAYLOAD"},
    {no: 4, name: "PAY_REQUEST_ERROR_CODE_INVALID_ROUTING_NUMBER", localName: "INVALID_ROUTING_NUMBER"},
    {no: 5, name: "PAY_REQUEST_ERROR_CODE_INELIGIBLE_PINLESS_PAYMENT_METHOD", localName: "INELIGIBLE_PINLESS_PAYMENT_METHOD"},
    {no: 6, name: "PAY_REQUEST_ERROR_CODE_AUTHENTICATION_REQUESTED", localName: "AUTHENTICATION_REQUESTED"},
    {no: 7, name: "PAY_REQUEST_ERROR_CODE_IGNORED_PAY_ATTEMPT", localName: "IGNORED_PAY_ATTEMPT"},
    {no: 8, name: "PAY_REQUEST_ERROR_CODE_SCA_EXEMPTION_REJECTED", localName: "SCA_EXEMPTION_REJECTED"},
    {no: 9, name: "PAY_REQUEST_ERROR_CODE_INVALID_CVV", localName: "INVALID_CVV"},
    {no: 10, name: "PAY_REQUEST_ERROR_CODE_CANCELLED_PAY_ATTEMPT", localName: "CANCELLED_PAY_ATTEMPT"},
    {no: 11, name: "PAY_REQUEST_ERROR_CODE_DUPLICATE_AUTHORIZE_ATTEMPT", localName: "DUPLICATE_AUTHORIZE_ATTEMPT"},
    {no: 12, name: "PAY_REQUEST_ERROR_CODE_ONGOING_OPERATION_ON_REFERENCE", localName: "ONGOING_OPERATION_ON_REFERENCE"},
    {no: 13, name: "PAY_REQUEST_ERROR_CODE_PAYMENT_ATTEMPT_ON_INACTIVE_LINK", localName: "PAYMENT_ATTEMPT_ON_INACTIVE_LINK"},
    {no: 14, name: "PAY_REQUEST_ERROR_CODE_PAYMENT_IN_PROGRESS", localName: "PAYMENT_IN_PROGRESS"},
  ],
);

/**
 * Defines error codes in case of failure response from refund.
 * This enum can grow as we support more errors.
 *
 * @generated from enum common.v1.RefundErrorCode
 */
export const RefundErrorCode = proto3.makeEnum(
  "common.v1.RefundErrorCode",
  [
    {no: 0, name: "REFUND_ERROR_CODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "REFUND_ERROR_CODE_NOT_ALLOWED", localName: "NOT_ALLOWED"},
    {no: 2, name: "REFUND_ERROR_CODE_INVALID_AMOUNT", localName: "INVALID_AMOUNT"},
    {no: 3, name: "REFUND_ERROR_CODE_IGNORED_REFUND_ATTEMPT", localName: "IGNORED_REFUND_ATTEMPT"},
    {no: 4, name: "REFUND_ERROR_CODE_INTERNAL_ERROR", localName: "INTERNAL_ERROR"},
    {no: 5, name: "REFUND_ERROR_CODE_INVALID_PAYLOAD", localName: "INVALID_PAYLOAD"},
    {no: 6, name: "REFUND_ERROR_CODE_SERVICE_UNAVAILABLE", localName: "SERVICE_UNAVAILABLE"},
    {no: 7, name: "REFUND_ERROR_CODE_SERVICE_TIMEOUT", localName: "SERVICE_TIMEOUT"},
    {no: 8, name: "REFUND_ERROR_CODE_DUPLICATE", localName: "DUPLICATE"},
  ],
);

/**
 * Defines error codes in case of failure response from cancel.
 * This enum can grow as we support more errors.
 *
 * @generated from enum common.v1.CancelErrorCode
 */
export const CancelErrorCode = proto3.makeEnum(
  "common.v1.CancelErrorCode",
  [
    {no: 0, name: "CANCEL_ERROR_CODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CANCEL_ERROR_CODE_INTERNAL_ERROR", localName: "INTERNAL_ERROR"},
    {no: 2, name: "CANCEL_ERROR_CODE_INVALID_PAYLOAD", localName: "INVALID_PAYLOAD"},
    {no: 3, name: "CANCEL_ERROR_CODE_IGNORED_CANCEL_ATTEMPT", localName: "IGNORED_CANCEL_ATTEMPT"},
    {no: 4, name: "CANCEL_ERROR_CODE_NOT_ALLOWED", localName: "NOT_ALLOWED"},
    {no: 5, name: "CANCEL_ERROR_CODE_SERVICE_UNAVAILABLE", localName: "SERVICE_UNAVAILABLE"},
    {no: 6, name: "CANCEL_ERROR_CODE_SERVICE_TIMEOUT", localName: "SERVICE_TIMEOUT"},
    {no: 7, name: "CANCEL_ERROR_CODE_DUPLICATE", localName: "DUPLICATE"},
    {no: 8, name: "CANCEL_ERROR_CODE_ALREADY_CANCELLED", localName: "ALREADY_CANCELLED"},
    {no: 9, name: "CANCEL_ERROR_CODE_ALREADY_CAPTURED", localName: "ALREADY_CAPTURED"},
    {no: 10, name: "CANCEL_ERROR_CODE_TRANSACTION_NOT_FOUND", localName: "TRANSACTION_NOT_FOUND"},
  ],
);

/**
 * Defines error codes in case of failure response from tips.
 * This enum can grow as we support more errors.
 *
 * @generated from enum common.v1.TipErrorCode
 */
export const TipErrorCode = proto3.makeEnum(
  "common.v1.TipErrorCode",
  [
    {no: 0, name: "TIP_ERROR_CODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TIP_ERROR_CODE_INTERNAL_ERROR", localName: "INTERNAL_ERROR"},
    {no: 2, name: "TIP_ERROR_CODE_INVALID_PAYLOAD", localName: "INVALID_PAYLOAD"},
    {no: 3, name: "TIP_ERROR_CODE_IGNORED_TIP_ATTEMPT", localName: "IGNORED_TIP_ATTEMPT"},
    {no: 4, name: "TIP_ERROR_CODE_NOT_ALLOWED", localName: "NOT_ALLOWED"},
    {no: 5, name: "TIP_ERROR_CODE_SERVICE_UNAVAILABLE", localName: "SERVICE_UNAVAILABLE"},
    {no: 6, name: "TIP_ERROR_CODE_SERVICE_TIMEOUT", localName: "SERVICE_TIMEOUT"},
    {no: 7, name: "TIP_ERROR_CODE_DUPLICATE", localName: "DUPLICATE"},
    {no: 8, name: "TIP_ERROR_CODE_ALREADY_COMPLETED", localName: "ALREADY_COMPLETED"},
  ],
);

/**
 * Defines error codes in case of failure response from nonce generation.
 * This enum can grow as we support more errors.
 *
 * @generated from enum common.v1.NonceGenerationErrorCode
 */
export const NonceGenerationErrorCode = proto3.makeEnum(
  "common.v1.NonceGenerationErrorCode",
  [
    {no: 0, name: "NONCE_GENERATION_ERROR_CODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "NONCE_GENERATION_ERROR_CODE_BAD_REQUEST", localName: "BAD_REQUEST"},
    {no: 2, name: "NONCE_GENERATION_ERROR_CODE_UNAUTHORIZED", localName: "UNAUTHORIZED"},
    {no: 3, name: "NONCE_GENERATION_ERROR_CODE_FORBIDDEN", localName: "FORBIDDEN"},
    {no: 4, name: "NONCE_GENERATION_ERROR_CODE_SERVICE_UNAVAILABLE", localName: "SERVICE_UNAVAILABLE"},
  ],
);

/**
 * Defines error codes in case of failure response from capture.
 * This enum can grow as we support more errors.
 *
 * @generated from enum common.v1.CaptureErrorCode
 */
export const CaptureErrorCode = proto3.makeEnum(
  "common.v1.CaptureErrorCode",
  [
    {no: 0, name: "CAPTURE_ERROR_CODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CAPTURE_ERROR_CODE_INTERNAL_ERROR", localName: "INTERNAL_ERROR"},
    {no: 2, name: "CAPTURE_ERROR_CODE_INVALID_PAYLOAD", localName: "INVALID_PAYLOAD"},
    {no: 3, name: "CAPTURE_ERROR_CODE_IGNORED_CAPTURE_ATTEMPT", localName: "IGNORED_CAPTURE_ATTEMPT"},
    {no: 4, name: "CAPTURE_ERROR_CODE_NOT_ALLOWED", localName: "NOT_ALLOWED"},
    {no: 5, name: "CAPTURE_ERROR_CODE_SERVICE_UNAVAILABLE", localName: "SERVICE_UNAVAILABLE"},
    {no: 6, name: "CAPTURE_ERROR_CODE_SERVICE_TIMEOUT", localName: "SERVICE_TIMEOUT"},
    {no: 7, name: "CAPTURE_ERROR_CODE_DUPLICATE", localName: "DUPLICATE"},
    {no: 8, name: "CAPTURE_ERROR_CODE_ALREADY_COMPLETED", localName: "ALREADY_COMPLETED"},
    {no: 9, name: "CAPTURE_ERROR_CODE_ALREADY_CANCELED", localName: "ALREADY_CANCELED"},
  ],
);

/**
 * PayRequestErrorDetail defines meta data fields which are used to annotate PayRequestErrorCode
 * enum values.
 *
 * @generated from message common.v1.PayRequestErrorDetail
 */
export const PayRequestErrorDetail = proto3.makeMessageType(
  "common.v1.PayRequestErrorDetail",
  () => [
    { no: 1, name: "frontend_error_visibility", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "generate_billable_event", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

